import { FC } from 'react';
import { isRouteErrorResponse } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { errorContainerStyles } from './styles';

interface GenericErrorProps {
  error: unknown;
}

const GenericError: FC<GenericErrorProps> = ({ error }) => {
  let message = 'Unexpected error occurred. Reload the app or try again later.';

  if (error instanceof Error) {
    message = error.message || message;
  } else if (isRouteErrorResponse(error)) {
    message = `${error.status} ${error.statusText}`.trim() || message;
  } else if (typeof error === 'string') {
    message = error;
  } else if (error) {
    message = JSON.stringify(error);
  }

  return (
    <Box sx={errorContainerStyles}>
      <Typography variant="h1">Error</Typography>
      <Typography variant="h3">{message}</Typography>
    </Box>
  );
};

export default GenericError;
